/** @module components/Form/FormGroupAddressSearchGoogle */

import { AddressSearchGoogle } from 'address-search-google';
import 'address-search-google/dist/index.css';
import { useLanguageState } from '../../contexts/language-state-provider';

type Props = {
  address: string;
  onCoordinates: FormOnCoordinates;
  onAddress: (v: string) => void;
  onQuotaError?: () => void;
};

const FormGroupAddressSearchGoogle = ({ address, onCoordinates, onAddress, onQuotaError }: Props) => {
  const [lang] = useLanguageState();
  return (
    <AddressSearchGoogle
      address={address}
      onAddress={onAddress}
      onCoordinates={(coords, _method) => onCoordinates(coords.latitude, coords.longitude)}
      onQuotaError={onQuotaError}
      languageCode={lang.abbr || 'en'}
    />
  );
};

export default FormGroupAddressSearchGoogle;
